<template>
  <button
    @click="toggleMode"
    class="relative p-2 rounded-lg transition-colors duration-200 hover:bg-[var(--chrome-pill-hover)] focus:outline-none"
    :style="{ color: 'var(--text-secondary)' }"
    aria-label="Toggle Theme"
  >
    <!-- Sun Icon (Light Mode) -->
    <svg
      v-if="!isDark"
      class="w-5 h-5 transition-transform duration-500 rotate-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>

    <!-- Moon Icon (Dark Mode) -->
    <svg
      v-else
      class="w-5 h-5 transition-transform duration-500 rotate-0"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
    </svg>
  </button>
</template>

<script setup lang="ts">
// 💬 Thin shell over useTheme — the composable owns all the
// localStorage + DOM-class wiring. Previously this component held
// the logic itself; we hoisted it out so the Settings → Appearance
// page can read/write the same state without duplicating the
// resolution rules.
const { isDark, toggleMode } = useTheme()
</script>
